import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  private reset: Subject<void> = new Subject<void>();
  private stepInProgress: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public getReset(): Observable<void> {
    return this.reset.asObservable();
  }

  public triggerReset(): void {
    this.reset.next();
  }

  public setStepInProgress(inProgress: boolean): void {
    this.stepInProgress.next(inProgress);
  }

  public isStepInProgress(): boolean {
    return this.stepInProgress.getValue();
  }

  public getStepInProgress(): Observable<boolean> {
    return this.stepInProgress.asObservable();
  }
}
